import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import {
	ALL_PROCESSED_INVOICES_QUERY_KEY,
	INVOICE_QUERY_KEY,
	PROJECTS_INVOICES_QUERY_KEY,
} from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import CreateInvoiceCommentForm
	from "~/modules/billing/components/InvoiceDetailsView/components/CreateInvoiceCommentSidebar/CreateInvoiceCommentForm";

type Props = {
	invoiceId: string
	isOpen: boolean;
	onClose: () => void;
	projectId: string|null;
};

const CreateInvoiceCommentSidebar: React.FunctionComponent<Props> = ({
	invoiceId,
	isOpen,
	onClose,
	projectId,
}) => {

	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: INVOICE_QUERY_KEY(invoiceId) });
		queryClient.invalidateQueries({ queryKey: ALL_PROCESSED_INVOICES_QUERY_KEY });
		if (projectId) {
			queryClient.invalidateQueries({ queryKey: PROJECTS_INVOICES_QUERY_KEY(projectId) });
		}
		onClose();
	}, [invoiceId, onClose, projectId, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={() => onClose()}>
			{isOpen && <CreateInvoiceCommentForm invoiceId={invoiceId}
												 onCancel={onClose}
												 onSuccess={handleSuccess} />}
		</Sidebar>
	);
};

export default CreateInvoiceCommentSidebar;
